// The get-started hero's greeting, shared with the AdminPortal so its
// read-only "derived greeting" preview and the dialog can never disagree.
// Deliberately import-free: AdminPortalWeb pulls app-common files into its
// own bundle (see capability-catalogue.ts for the precedent).

/**
 * Time-of-day greeting from the DEVICE clock (display is viewer-local
 * throughout the product). Late night (before 5) reads as evening:
 * "Good morning" at 2am is worse.
 */
export function greetingForHour(hour: number, name?: string | null): string {
    const base =
        hour >= 5 && hour < 12 ? 'Good morning' :
        hour >= 12 && hour < 18 ? 'Good afternoon' :
        'Good evening';
    return name ? `${base}, ${name}.` : `${base}.`;
}

/**
 * A greeting-worthy first name out of the signup Name field, or null for
 * the nameless greeting. The field is free text (full names, companies,
 * all-caps, emails, blanks), so this guards conservatively; the one miss
 * it cannot catch is a company name that looks personal ("Spectrum
 * Energy" greets as Spectrum). A user-editable greeting name in the
 * server settings is the intended long-term correction path.
 */
/**
 * The name the greeting should use: an explicit greetingName from the
 * server-backed user settings wins (as typed, trimmed - it was entered
 * deliberately by the user or an admin); otherwise derive from the signup
 * Name. `unknown` because stored settings JSON outlives code.
 */
export function resolveGreetingName(settingsGreetingName: unknown, fullName: string | undefined): string | null {
    const override = typeof settingsGreetingName === 'string' ? settingsGreetingName.trim() : '';
    if (override) return override;
    return greetingNameFrom(fullName);
}

export function greetingNameFrom(fullName: string | undefined): string | null {
    const token = (fullName || '').trim().split(/\s+/)[0] || '';
    if (token.length < 2 || token.length > 15) return null;
    if (!/^\p{L}[\p{L}'’-]*$/u.test(token)) return null;
    const unshouted = token === token.toUpperCase() && token.length > 2
        ? token.charAt(0) + token.slice(1).toLowerCase()
        : token;
    return unshouted.charAt(0).toUpperCase() + unshouted.slice(1);
}
